import settings from "../utils/settings";
import {
  getList,
  create,
  createwithImage,
  getOne,
  update,
  updatewithImage,
  getManyReference,
  cleanResultforList,
  cleanResultforOne,
  cleanResultforMany,
  deleteOne,
} from "./wgModels";
import { Resources, RESOURCES_WITH_BRANCH } from "./wgProviderHelper";

const wgProvider = {
  getList: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      try {
        //change pagination to limit and skip
        /*
        {"pagination":{"page":1,"perPage":25},"sort":{"field":"id","order":"DESC"},"filter":{}}
        */

        const resourceResult = Resources.find((res) => res.path === resource);
        if (resourceResult && resourceResult.projection) {
          params["projection"] = JSON.stringify(resourceResult.projection);
        }

        if (resourceResult && resourceResult.addon) {
          params["addon"] = JSON.stringify(resourceResult.addon);
        }

        if (params.pagination) {
          params["limit"] = params.pagination.perPage;
          params["skip"] =
            (params.pagination.page - 1) * params.pagination.perPage;
          delete params.pagination;
        }

        if (params.sort) {
          if (params.sort.field === "None") {
            delete params.sort;
          } else {
            params.sort = JSON.stringify({
              [params.sort.field]: params.sort.order === "ASC" ? 1 : -1,
            });
          }
        } //else console.log("No sort");

        if (params.filter) {
          if (params.filter.from) {
            params.from = params.filter.from;
            delete params.filter.from;
          }
          if (params.filter.to) {
            params.to = params.filter.to;
            delete params.filter.to;
          }

          if (params.filter.search_term_name) {
            params.search_term = params.filter.search_term_name;
            delete params.filter.search_term_name;
          }

          params.filter = JSON.stringify(params.filter);
        }

        if (RESOURCES_WITH_BRANCH.some((res) => res === resource)) {
          const { branchId } = settings();
          if (branchId) params.branch_id = branchId; //params.filter.branch_id = branchId;
        }

        if (!params.locale) {
          params.locale = "th-TH";
        }

        let rawResult = await getList(resource, params);

        if (rawResult.wgStatus < 200 || rawResult.wgStatus >= 300) {
          return reject(
            JSON.stringify({
              status: rawResult.wgStatus,
              code: rawResult.code,
              message: createNiceErrorMessage(rawResult.message),
            })
          );
        }

        let [result, total] = cleanResultforList(resource, rawResult.payload);
        if (!result) {
          result = [];
        }

        return resolve({ data: result, total: total });
      } catch (error) {
        return reject(error);
      }
    });
  },
  getOne: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      try {
        const resourceResult = Resources.find((res) => res.path === resource);

        if (resourceResult && resourceResult.projection) {
          params["projection"] = resourceResult.projection;
        }

        if (resourceResult && resourceResult.addon) {
          if (params["addon"]) {
            //console.log("Already have addon");
          }
          // console.log("Don't have it" + JSON.stringify(params));
          params["addon"] = JSON.stringify(resourceResult.addon);
        }

        const rawResult = await getOne(resource, params);

        if (rawResult.wgStatus < 200 || rawResult.wgStatus >= 300) {
          return reject(
            JSON.stringify({
              status: rawResult.wgStatus,
              code: rawResult.code,
              message: rawResult.message,
            })
          );
        }
        const result = cleanResultforOne(resource, rawResult.payload);

        return resolve({ data: result });
      } catch (error) {
        return reject(error);
      }
    });
  },
  getMany: (resource, params) => {
    //This is for filter

    return new Promise(async (resolve, reject) => {
      try {
        //Get number of stock
        if (resource === "stock") {
          params.filter = JSON.stringify({ product_id: params.ids[0] });
          //delete params.filter;
          params.filter = JSON.stringify({
            $or: params.ids.reduce((total, currId) => {
              total.push({ product_id: currId });
              return total;
            }, []),
          });
        } else {
          params.filter = JSON.stringify({ id: { $in: params.ids } });
        }

        let rawResult = await getList(resource, params);
        let [result, total] = cleanResultforMany(resource, rawResult.payload);

        return resolve({ data: result, total: total });
      } catch (error) {
        console.error(JSON.stringify(error));
        return reject(error);
      }
    });
  },
  getManyReference: (resource, params) => {
    /** 
     * Params {"target":"product_id","id":"prodct-601a5e4993857601af676de2",
     "pagination": { "page": 1, "perPage": 25 }, "sort": { "field": "id", "order": "DESC" },
     "filter": { }

     return require
     [
    { "id": 667, "title": "I agree", "post_id": 123 },
    { "id": 895, "title": "I don't agree", "post_id": 123 }
     ]
     */

    return new Promise(async (resolve, reject) => {
      try {
        const rawResult = await getManyReference(resource, params);

        const result = cleanResultforOne(resource, rawResult.payload);

        return resolve({ data: result });
      } catch (error) {
        console.error(error);
        return reject(error);
      }
    });
  },
  create: (resource, params) => {
    //Check if have params.data.image will go to use upload with image function
    return new Promise(async (resolve, reject) => {
      try {
        let result;

        if (!params.data) params.data = {};
        params.data.locale = getLocale();

        if (params.data.image) {
          params.data.action = "upload_image";
          result = await createwithImage(resource, params.data);
        } else result = await create(resource, params.data);

        if (result.wgStatus < 200 || result.wgStatus >= 300) {
          return reject(
            JSON.stringify({
              status: result.wgStatus,
              code: result.code,
              wgCode: result.wgCode,
              message: createNiceErrorMessage(result.message),
            })
          );
        }

        //Check if there is no id in response then mock it

        if (!result.payload.id)
          result.payload.id = resource + String(Math.random() * 2000);

        return resolve({ data: result.payload });
      } catch (error) {
        return reject(
          JSON.stringify({
            status: error.status,
            code: error.code,
            wgCode: error.wgCode,
            message: createNiceErrorMessage(error.message),
          })
        );
      }
    });
  },
  update: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      //  console.log(JSON.stringify(params));
      try {
        let result;
        if (params.data.image) {
          params.data.action = "upload_image";
          result = await updatewithImage(resource, params.data);
        } else result = await update(resource, params.data);

        if (result.wgStatus < 200 || result.wgStatus >= 300) {
          return reject(
            JSON.stringify({
              // status: result.wgStatus,
              // code: result.code,
              message: createNiceErrorMessage(result.message),
            })
          );
        }

        if (!result) {
          return reject(result);
        }

        return resolve({ data: { id: params.data.id } });
      } catch (error) {
        return reject(
          JSON.stringify({
            status: error.status,
            code: error.code,
            message: error.message,
          })
        );
      }
    });
  },
  updateMany: (resource, params) => {
    return new Promise((resolve, reject) => {
      resolve();
    });
  },
  delete: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      const result = await deleteOne(resource, params);
      if (result.wgStatus < 200 || result.wgStatus >= 300) {
        return reject(
          JSON.stringify({
            // status: result.wgStatus,
            // code: result.code,
            message: createNiceErrorMessage(result.message),
          })
        );
      }
      return resolve({ data: { id: params.id } });
    });
  },
  deleteMany: (resource, params) => {
    return new Promise((resolve, reject) => {
      resolve();
    });
  },
};

const getLocale = () => {
  return "th-TH";
};

const createNiceErrorMessage = (badMessage = "Unknown") => {
  //return badMessage;
  if (Array.isArray(badMessage)) {
    const instances = badMessage[0].instancePath?.split("/") ?? null;
    if (!instances) return "";
    const field = instances[instances.length - 1];

    return `${field} ${badMessage[0].message}`;
  }
  if (badMessage) {
    return badMessage;
  }
};

export default wgProvider;
